const accountreconciliationDt       = require('./accountreconciliation-dt')
const accountreconciliationFullcont = require('./accountreconciliation-fullcont')
const accountreconciliationPage     = require('./accountreconciliation-page')

export function start(detail) {
      obj[detail.elem].start(detail)
}

const obj = {
      dt:       { start: (detail)=>{ accountreconciliationDt.start(detail)       }},
      fullcont: { start: (detail)=>{ accountreconciliationFullcont.start(detail) }},
      page:     { start: (detail)=>{ accountreconciliationPage.start(detail)     }},
}
